/** atonce/stats — licznik od 0 do wartości (makieta online c6: 1200 ms easeOutCubic), start gdy górna krawędź listy przekroczy 85 % okna (eo(.15)). Reduced-motion: od razu wartość. */
( function () {
	const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	// Jak online: grupy po 3 cyfry (także 4-cyfrowe) rozdzielone szczeliną 0,28ch (span .st__gs), niezależnie od języka strony.
	const GS = '<span class="st__gs" aria-hidden="true"></span>';
	const fmt = ( n ) => String( n ).replace( /\B(?=(\d{3})+(?!\d))/g, ' ' ).split( ' ' ).join( GS );
	const run = ( el ) => {
		const end = parseInt( el.dataset.count, 10 ) || 0;
		if ( reduce || ! end ) {
			el.innerHTML = fmt( end );
			return;
		}
		const dur = 1200;
		const t0 = performance.now();
		const tick = ( t ) => {
			const p = Math.min( 1, ( t - t0 ) / dur );
			const eased = 1 - Math.pow( 1 - p, 3 );
			el.innerHTML = fmt( Math.round( end * eased ) );
			if ( p < 1 ) {
				requestAnimationFrame( tick );
			}
		};
		el.innerHTML = fmt( 0 );
		requestAnimationFrame( tick );
	};
	document.querySelectorAll( '[data-stats]' ).forEach( ( root ) => {
		const digits = root.querySelectorAll( '.st__digits' );
		if ( ! ( 'IntersectionObserver' in window ) || reduce ) {
			return;
		}
		// makieta online: przed startem liczby stoją na „0”, a start liczy się od listy kafli (nie od nagłówka sekcji)
		digits.forEach( ( el ) => { el.innerHTML = fmt( 0 ); } );
		const list = root.querySelector( '.st__list' ) || root;
		const io = new IntersectionObserver( ( entries ) => {
			if ( entries.some( ( e ) => e.isIntersecting ) ) {
				digits.forEach( run );
				io.disconnect();
			}
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0 } );
		io.observe( list );
	} );
} )();
